import React, { useState } from 'react';
import { FaWhatsapp, FaUser, FaEnvelope, FaPhone, FaUsers, FaComment, FaCalendarAlt } from 'react-icons/fa';
import { companyInfo } from '../../data/tourData';
import './BookingForm.css';

const BookingForm = ({ tourName, tourPrice, tourDuration }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    travelers: '',
    preferredDate: '',
    specialRequirements: ''
  });
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form data
    if (!formData.fullName || !formData.email || !formData.phone || !formData.travelers || !formData.preferredDate) {
      showMessage('Please fill in all required fields.', 'error');
      return;
    }

    // Show loading state
    showMessage('Submitting booking...', 'info');

    try {
      // Use Web3Forms (Free service - get your access key from https://web3forms.com)
      const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_KEY || 'YOUR_WEB3FORMS_ACCESS_KEY';
      
      const bookingData = {
        access_key: WEB3FORMS_ACCESS_KEY,
        subject: `New Tour Booking: ${tourName || 'Tour Booking'}`,
        from_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        tour_name: tourName || 'Tour Booking',
        tour_price: tourPrice || 'Not specified',
        tour_duration: tourDuration || 'Not specified',
        number_of_travelers: formData.travelers,
        preferred_date: formData.preferredDate,
        special_requirements: formData.specialRequirements || 'None',
        timestamp: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
      };

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(bookingData)
      });

      const result = await response.json();

      if (result.success) {
        showMessage('Booking submitted successfully! We\'ll contact you soon.', 'success');
        resetForm();
      } else {
        showMessage('Submission failed. Please try again or contact us directly.', 'error');
      }
      
    } catch (error) {
      console.error('Submission error:', error);
      showMessage('Network error. Please try again or contact us directly.', 'error');
    }
  };

  const showMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    
    // Auto-hide message after 5 seconds
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 5000);
  };

  const resetForm = () => {
    setFormData({
      fullName: '',
      email: '',
      phone: '',
      travelers: '',
      preferredDate: '',
      specialRequirements: ''
    });
  };

  return (
    <div className="booking-form-container">
      <div className="booking-form-header">
        <h3>Book This Tour</h3>
      </div>
      
      <form className="booking-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <div className="input-wrapper">
            <FaUser className="input-icon" />
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="input-wrapper">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="input-wrapper">
            <FaPhone className="input-icon" />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="input-wrapper">
            <FaUsers className="input-icon" />
            <select
              name="travelers"
              value={formData.travelers}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Number of People</option>
              <option value="1">1 Person</option>
              <option value="2">2 People</option>
              <option value="3">3 People</option>
              <option value="4">4 People</option>
              <option value="5">5 People</option>
              <option value="6+">6+ People</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <div className="input-wrapper">
            <FaCalendarAlt className="input-icon" />
            <input
              type="date"
              name="preferredDate"
              placeholder="Preferred Date"
              value={formData.preferredDate}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="input-wrapper">
            <FaComment className="input-icon" />
            <textarea
              name="specialRequirements"
              placeholder="Special Requirements (Optional)"
              rows="3"
              value={formData.specialRequirements}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <button type="submit" className="book-now-btn">
          <FaWhatsapp />
          Book Now
        </button>
      </form>

      {message && (
        <div className={`booking-message ${messageType}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default BookingForm;
